var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"TextInput",class:{ half: _vm.half, quarter: _vm.quarter, third: _vm.third, center: _vm.center }},[_c('input',{attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []

export { render, staticRenderFns }